/**
 * @Author: Li, Yu Jia
 * @Date: 2019-12-02 13:36:31
 * @Last Modified by: Li, Yu Jia
 * @Last Modified time: 2020-09-11 09:13:11
 * @Usage: imprintarea.reducers.fun
 */

import {
  imprintAreasCombinedInit,
  imprintAreasCombinedSelect,
  imprintAreasInit,
  imprintColorInitialize,
  imprintColorUpdate,
  imprintOptionTypeInit,
  imprintOptionTypeSelect,
  imprintThumbnailInitialize,
  logoLayoutInit,
  logoLayoutSelect,
  logoLayoutSelectDefault,
  textLayoutInit,
  textLayoutSelect,
  textLayoutSelectDefault,
} from './actions';

import { createReducer } from '@reduxjs/toolkit';
import { formatsCompare } from './logics';

const imprintAreasInitialState = {};
const imprintAreaDict = createReducer(imprintAreasInitialState, (builder) => {
  builder.addCase(imprintAreasInit, (state, action) => {
    Object.assign(state, action.payload.formats);
  });
});

const imprintAreasCombinedInitialState = {};
const imprintAreasCombinedDict = createReducer(imprintAreasCombinedInitialState, (builder) => {
  builder
    .addCase(imprintAreasCombinedInit, (state, action) => {
      Object.assign(state, action.payload.groups);
    })
    .addCase(imprintAreasCombinedSelect, (state, action) => {
      const { formatSelected, groupKey } = action.payload;
      if (state[groupKey]) {
        state[groupKey].combinations.map((com, _) => {
          com.selected = formatsCompare([...com.formats], [...formatSelected]);
          return true;
        });
      }
    });
});

const imprintLocationInitialState = {};
const imprintLocationDict = createReducer(imprintLocationInitialState, (builder) => {
  builder
    .addCase(textLayoutInit, (state, action) => action.payload)
    .addCase(textLayoutSelectDefault, (state, action) => {
      const fromatSelected = action.payload;
      Object.keys(state).map((key, _) => {
        const selected = fromatSelected.findIndex((x) => x === key) > -1;
        state[key].map((location, _) => {
          location.selected = selected;
          return true;
        });
        return true;
      });
    })
    .addCase(textLayoutSelect, (state, action) => {
      const { formatkey, locationSelected } = action.payload;
      state[formatkey] &&
        state[formatkey].forEach((type, _) => {
          type['selected'] = type.locationCode === locationSelected.key;
        });
    });
});

const logoLocationDictInitialState = {};
const logoLocationDict = createReducer(logoLocationDictInitialState, (builder) => {
  builder
    .addCase(logoLayoutInit, (state, action) => action.payload)
    .addCase(logoLayoutSelectDefault, (state, action) => {
      const fromatSelected = action.payload;
      Object.keys(state).map((key, _) => {
        const selected = fromatSelected.findIndex((x) => x === key) > -1;
        state[key].map((location, _) => {
          location.selected = selected;
          return true;
        });
        return true;
      });
    })
    .addCase(logoLayoutSelect, (state, action) => {
      const { formatkey, locationSelected } = action.payload;
      state[formatkey] &&
        state[formatkey].forEach((type, _) => {
          type['selected'] = type.locationCode === locationSelected.key;
        });
    });
});

const imprintOptionTypeDictInitialState = {};
const imprintOptionTypeDict = createReducer(imprintOptionTypeDictInitialState, (builder) => {
  builder
    .addCase(imprintOptionTypeInit, (state, action) => action.payload)
    .addCase(imprintOptionTypeSelect, (state, action) => {
      const { formatkey, typeSelected } = action.payload;
      state[formatkey] &&
        state[formatkey].forEach((type, _) => {
          type['selected'] = type.key === typeSelected.key;
        });
    });
});
const imprintColorDict = createReducer({}, (builder) => {
  builder
    .addCase(imprintColorInitialize, (state, action) => action.payload)
    .addCase(imprintColorUpdate, (state, action) => {
      const { imprintAreaCode, imprintColors } = action.payload;

      state[imprintAreaCode] = imprintColors;
    });
});

const imprintThumbnailsDict = createReducer({}, (builder) => {
  builder.addCase(imprintThumbnailInitialize, (state, action) => action.payload);
});

const imprintAreaReducer = {
  imprintAreaDict,
  imprintAreasCombinedDict,
  imprintLocationDict,
  logoLocationDict,
  imprintOptionTypeDict,
  imprintColorDict,
  imprintThumbnailsDict,
};
export default imprintAreaReducer;
